import "../Sys/config.js";
import { withMoodleIdentityCheck } from 'utils/moodleSingleLogout';
import { IMPERSONATION_BLOCKED_MESSAGE, isImpersonating } from './impersonationSession';

export const authService = {
  login,
  forgotPassword,
  resetpassword,
  gettheme,
  adminlogin,
  ssologin,
  callback
};

const apiUrl = global.platformURI;
//'https://calendar-api.deviare.africa/';

const cookieUrl = process.env.REACT_APP_KEYCLOAK_COOKIE_ENDPOINT;
const relayUrl = process.env.REACT_APP_KEYCLOAK_RELAY;
function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  };
  return fetch(`${apiUrl}main/authorize`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}
function adminlogin(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  };

  return fetch(`${apiUrl}main/authorize`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}
function gettheme(branch_url) {
  return fetch(`${apiUrl}main/customertheme?branch_url=` + branch_url)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}
function callback(code, state, courseid) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      code: code,
      state: state,
      courseid: courseid
    })
  };
  return fetch(`${apiUrl}main/authprovider`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}
function ssologin(getprams) {
  let url = `${apiUrl}main/authprovider`;
  if (getprams) {
    url = url + '?' + getprams;
  }

  return fetch(url)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}

function forgotPassword(username) {
  if (isImpersonating()) {
    return Promise.resolve({ status: false, message: IMPERSONATION_BLOCKED_MESSAGE });
  }
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: username })
  };
  return fetch(`${apiUrl}main/forgetpassword`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    })
    .catch(err => (err.response && err.response.data) ? err.response.data : err);
}

function resetpassword(userName, token, newPassword) {
  if (isImpersonating()) {
    return Promise.resolve({ status: false, message: IMPERSONATION_BLOCKED_MESSAGE });
  }
  console.log('restting password');
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username: userName,
      token: token,
      password: newPassword
    })
  };
  console.log('requestOptions', requestOptions);
  return fetch(`${apiUrl}main/resetpassword`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
      }

      const error = data || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// Resolves the destination URL for an SSO-launched course without navigating
// anywhere, so callers can either open it (handleSSOAuth) or embed it in an
// iframe to keep the current page URL unchanged.
export const getSSOAuthUrl = (courseUrl, client, category) => {
  let token = localStorage.getItem('IDP:SSOToken');
  let ssoToken = { url_search_string: localStorage.getItem('SSO') };
  try {
    ssoToken = JSON.parse(atob(token));
  } catch (error) {
    ssoToken = { url_search_string: localStorage.getItem('SSO') };
  }
  if (!ssoToken || !courseUrl) {
    console.log('Data Not Found');
    return null;
  }
  // Preserve the established behavior: every valid course opens directly.
  return courseUrl;
};

export const handleSSOAuth = (courseUrl, client, category) => {
  try {
    const resolvedUrl = getSSOAuthUrl(courseUrl, client, category);
    if (resolvedUrl) {
      window.open(withMoodleIdentityCheck(resolvedUrl));
    }
  } catch (error) {
    alert(error);
  }
};
window.handleSSOAuth = handleSSOAuth;
window.cookieUrl = cookieUrl;
window.relayUrl = relayUrl;
